import { NgModule } from '@angular/core';
import { FrameReturnRoutingModule } from './frame-return-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { FrameReturnComponent } from '@app/frame-returns/frame-return.component';
import * as fromComponents from './components';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';

// import { ExportBrandComponent } from '@app/shared/components/export-brand/export-brand.component';
/**
 * CatalogModule
 */
@NgModule({
  imports: [SharedModule, FrameReturnRoutingModule, CommonModule, MatButtonModule, MatTooltipModule, MatIconModule],
  declarations: [
    FrameReturnComponent,
    ...fromComponents.components,
    // ExportBrandComponent,
  ],
  providers: [],
  exports: [FrameReturnComponent, ...fromComponents.components],
  // entryComponents: [fromComponents.ExportBrandComponent],
})
export class FrameReturnModule {}
